import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import EventsSection from './components/EventsSection';
import FeaturesSection from './components/FeaturesSection';
import ProductsPreviewSection from './components/ProductsPreviewSection';
import QualityTimeline from './components/QualityTimeline';
import ResellerCTA from './components/ResellerCTA';
import ComparisonSection from './components/ComparisonSection';
import GallerySection from './components/GallerySection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CommercialInfo from './components/CommercialInfo';
import MapSection from './components/MapSection';
import InstagramSection from './components/InstagramSection';

export default function Home() {
  return (
    <main className="min-h-screen">
      <HeroSection />
      <AboutSection />
      <ComparisonSection />
      <FeaturesSection />
      <ProductsPreviewSection />
      <QualityTimeline />
      <ResellerCTA />
      <EventsSection />
      <GallerySection />
      <TestimonialsSection />
      <FAQSection />
      <CommercialInfo />
      <MapSection />
      <InstagramSection />
    </main>
  );
}